import { Injectable } from "@angular/core";
import { InitBootstrapAction } from "./init-bootstrap.action";
import { InitPermissionsAction } from "./init-permissions.action";
import { InitUIMessageBrokerAction } from "./init-ui-message-broker.actions";

@Injectable({
    providedIn: 'root'
  })
export class InitService {

    constructor(
        private initBootstrapAction: InitBootstrapAction,
        private initPermissionsAction: InitPermissionsAction,
        private initUiMessageBrokerAction: InitUIMessageBrokerAction) {

        }


  async init(): Promise<void> {
    // Single BFF roundtrip — replaces what used to be the Configuration +
    // NavigationRules load (and the static GETs they wrapped).
    await this.initBootstrapAction.load();
    // Permissions must load BEFORE the UI message broker connects, because
    // registerEventsByRole() inside connect() checks hasRoleAdmin() etc. at
    // SSE-setup time. If permissions are empty, zero role-based event listeners
    // are wired (LOG-EVENT, THREAD-DUMP, GC-EVENT, etc. all silently dropped).
    await this.initPermissionsAction.load();
    await this.initUiMessageBrokerAction.load();
  }


}